import React from 'react';
import { Table } from 'rsuite';
import { ProductListItem } from '../../api/apiTypes';

function getFormattedB2bPrice(product: ProductListItem): string | undefined {
  const { b2bPrice } = product;

  if (!b2bPrice) {
    return undefined;
  }

  return `${b2bPrice} ${product.b2bPriceCurrency}`;
}

const b2bPriceColumns = (
  <Table.Column width={120} align="center" sortable>
    <Table.HeaderCell>
      B2B price
    </Table.HeaderCell>
    <Table.Cell dataKey="b2bPrice">
      {rowData => getFormattedB2bPrice(rowData as ProductListItem)}
    </Table.Cell>
  </Table.Column>
);

export default b2bPriceColumns;
